import { api } from "./apiClient";

export const providerService = {
  markets: async () => (await api.get("/admin/markets")).data,
  engineStatus: async () => (await api.get("/admin/price-engine/status")).data,
  coverage: async () => (await api.get("/admin/providers/coverage")).data,
  staleAssets: async (hours) =>
    (await api.get("/admin/price-engine/stale", { params: hours ? { hours } : {} })).data,
  engineRefresh: async (market) =>
    (await api.post(`/admin/price-engine/refresh`, null, { params: { market } })).data,
  list: async () => (await api.get("/admin/providers")).data,
  create: async (payload) => (await api.post("/admin/providers", payload)).data,
  update: async (slug, payload) => (await api.patch(`/admin/providers/${slug}`, payload)).data,
  remove: async (slug) => (await api.delete(`/admin/providers/${slug}`)).data,
  test: async (slug) => (await api.post(`/admin/providers/${slug}/test`)).data,
  addKey: async (slug, payload) => (await api.post(`/admin/providers/${slug}/keys`, payload)).data,
  updateKey: async (id, payload) => (await api.patch(`/admin/keys/${id}`, payload)).data,
  deleteKey: async (id) => (await api.delete(`/admin/keys/${id}`)).data,
  history: async () => (await api.get("/admin/api-history")).data,
};

export const marketConfigService = {
  list: async () => (await api.get("/admin/market-config")).data,
  create: async (payload) => (await api.post("/admin/market-config", payload)).data,
  update: async (id, payload) => (await api.patch(`/admin/market-config/${id}`, payload)).data,
  remove: async (id) => (await api.delete(`/admin/market-config/${id}`)).data,
};
